import { Box, Typography, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { Outlet } from "react-router-dom";

import DirectoryNavRail from "../../components/Directory/DirectoryNavRail";
import {
  heroText,
  motionVariants,
  pageBackground,
} from "../../helpers/designSystem";

/**
 * Route element for /directory. Renders:
 *   - Page hero ("Directory")
 *   - <DirectoryNavRail /> horizontal sub-nav
 *   - <Outlet /> for the active child (Accounts / Users / Groups / Roles)
 *
 * Wrapped upstream in <ProtectedRoutes requiredRole={[SYSTEM,
 * DIRECTORY_ADMIN, ACCOUNT_ADMIN]} /> in src/App.js so
 * unauthorized users never see the hero. The Accounts tab is
 * additionally SYSTEM-only, filtered in the nav rail itself.
 */
export default function DirectoryLayout() {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Box
      sx={{
        ...pageBackground(isDarkMode),
        mx: -3,
        mt: -3,
        px: 3,
        pt: 3,
        pb: 4,
        minHeight: "calc(100vh - 96px)",
      }}
    >
      <Box
        component={motion.div}
        initial="initial"
        animate="animate"
        variants={motionVariants?.heroEnter}
        sx={{ mb: 2 }}
      >
        <Typography
          variant="h4"
          sx={{ ...heroText(isDarkMode), fontWeight: 700, letterSpacing: "-0.01em" }}
        >
          Directory
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", mt: 0.5, maxWidth: 640 }}
        >
          Who is on the platform. Accounts, users, groups, and roles —
          cross-tenant for SYSTEM operators, own-account for Account
          Admins.
        </Typography>
      </Box>

      <DirectoryNavRail />

      <Outlet />
    </Box>
  );
}
